import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  ru: {
    translation: {
      // Navigation
      nav: {
        dashboard: 'Обзор',
        portfolios: 'Портфели',
        transactions: 'Транзакции',
        import: 'Импорт',
        realestate: 'Недвижимость',
        otherassets: 'Прочие активы',
        pipelines: 'Воронки',
        captables: 'Cap Tables',
        tax: 'Налоги',
        dividends: 'Дивиденды',
        screener: 'Скринер',
        community: 'Сообщество',
        public: 'Публичные',
        pricing: 'Тарифы',
        settings: 'Настройки',
        logout: 'Выйти',
      },
      // Auth
      auth: {
        login: 'Вход',
        register: 'Регистрация',
        email: 'Email',
        password: 'Пароль',
        confirmPassword: 'Подтвердите пароль',
        fullName: 'Полное имя',
        loginButton: 'Войти',
        registerButton: 'Зарегистрироваться',
        noAccount: 'Нет аккаунта?',
        hasAccount: 'Уже есть аккаунт?',
        forgotPassword: 'Забыли пароль?',
        twoFactorCode: 'Код 2FA',
      },
      // Dashboard
      dashboard: {
        title: 'Обзор портфеля',
        netWorth: 'Чистая стоимость',
        totalValue: 'Общая стоимость',
        dayChange: 'Изменение за день',
        totalReturn: 'Общая доходность',
        allocation: 'Распределение активов',
        topHoldings: 'Топ позиции',
        recentTransactions: 'Последние транзакции',
        performance: 'Динамика',
      },
      // Portfolio
      portfolio: {
        title: 'Портфели',
        create: 'Создать портфель',
        name: 'Название',
        baseCurrency: 'Базовая валюта',
        holdings: 'Позиции',
        transactions: 'Транзакции',
        performance: 'Доходность',
        noHoldings: 'Нет позиций',
        addTransaction: 'Добавить транзакцию',
      },
      // Holdings
      holdings: {
        asset: 'Актив',
        quantity: 'Количество',
        avgCost: 'Средняя цена',
        currentPrice: 'Текущая цена',
        value: 'Стоимость',
        pnl: 'P&L',
        weight: 'Доля',
      },
      // Transactions
      transactions: {
        title: 'Транзакции',
        add: 'Добавить',
        import: 'Импорт',
        type: 'Тип',
        date: 'Дата',
        asset: 'Актив',
        quantity: 'Количество',
        price: 'Цена',
        total: 'Сумма',
        fees: 'Комиссия',
        notes: 'Заметка',
        currency: 'Валюта',
        selectAsset: 'Выберите актив',
        addDetails: 'Детали транзакции',
        searchAsset: 'Поиск по тикеру или названию...',
        noAssets: 'Активы не найдены',
        createAsset: 'Создать новый актив',
        assetType: 'Тип актива',
        ticker: 'Тикер',
        assetName: 'Название',
        notesPlaceholder: 'Необязательная заметка...',
        created: 'Транзакция создана',
        types: {
          buy: 'Покупка',
          sell: 'Продажа',
          dividend: 'Дивиденд',
          coupon: 'Купон',
          transfer_in: 'Зачисление',
          transfer_out: 'Списание',
          split: 'Сплит',
          fee: 'Комиссия',
          tax: 'Налог',
          interest: 'Проценты',
        },
      },
      // Cap Tables
      captable: {
        title: 'Cap Tables',
        create: 'Создать Cap Table',
        companyName: 'Название компании',
        totalShares: 'Всего акций',
        optionPool: 'Option Pool',
        rounds: 'Раунды',
        shareholders: 'Акционеры',
        grants: 'Гранты',
        waterfall: 'Waterfall анализ',
        addRound: 'Добавить раунд',
        addGrant: 'Добавить грант',
        ownership: 'Доля',
        fullyDiluted: 'Fully Diluted',
      },
      // Settings
      settings: {
        title: 'Настройки',
        profile: 'Профиль',
        security: 'Безопасность',
        appearance: 'Внешний вид',
        language: 'Язык',
        theme: 'Тема',
        currency: 'Валюта',
        enable2FA: 'Включить 2FA',
        disable2FA: 'Отключить 2FA',
        changePassword: 'Сменить пароль',
      },
      // Deposit Comparison Widget
      depositComparison: {
        title: 'Лучше депозитов',
        subtitle: 'Инструменты с доходностью выше вклада при сопоставимом риске',
        keyRate: 'Ключевая ставка ЦБ',
        depositRate: 'Типичный вклад',
        yield: 'Доходность',
        risk: 'Риск',
        horizon: 'Горизонт',
        liquidity: 'Ликвидность',
        minAmount: 'Мин. сумма',
        details: 'Подробнее',
        collapse: 'Свернуть',
        badgeBest: 'Лучший выбор',
        badgeSafe: 'Безопасный',
        badgePopular: 'Популярный',
        vsDeposit: 'vs вклад',
        aboveDeposit: 'выше вклада',
      },
      // Common
      common: {
        save: 'Сохранить',
        cancel: 'Отмена',
        delete: 'Удалить',
        edit: 'Редактировать',
        loading: 'Загрузка...',
        error: 'Ошибка',
        success: 'Успешно',
        confirm: 'Подтвердить',
        search: 'Поиск',
        filter: 'Фильтр',
        export: 'Экспорт',
        noData: 'Нет данных',
        back: 'Назад',
        create: 'Создать',
        previous: 'Назад',
        next: 'Далее',
        pageOf: 'Страница {{current}} из {{total}}',
        login: 'Войти',
      },
      // Community
      community: {
        title: 'Сообщество',
        subtitle: 'Статьи и аналитика от инвесторов',
        writeArticle: 'Написать статью',
        searchPlaceholder: 'Поиск статей...',
        allCategories: 'Все категории',
        noArticles: 'Нет статей',
        noArticlesDescription: 'Станьте первым, кто поделится своими мыслями',
        writeFirstArticle: 'Написать первую статью',
        anonymousAuthor: 'Аноним',
        backToArticles: 'Назад к статьям',
        articleNotFound: 'Статья не найдена',
        share: 'Поделиться',
        edit: 'Редактировать',
        delete: 'Удалить',
        confirmDelete: 'Вы уверены, что хотите удалить эту статью?',
        views: 'просмотров',
        followers: 'подписчиков',
        follow: 'Подписаться',
        unfollow: 'Отписаться',
        comments: 'Комментарии',
        commentPlaceholder: 'Напишите комментарий...',
        replyPlaceholder: 'Напишите ответ...',
        postComment: 'Отправить',
        reply: 'Ответить',
        edited: 'изменено',
        loginToComment: 'Войдите, чтобы оставить комментарий',
        noComments: 'Пока нет комментариев',
        category: {
          analysis: 'Аналитика',
          strategy: 'Стратегия',
          news: 'Новости',
          education: 'Обучение',
          review: 'Обзор',
          other: 'Другое',
        },
      },
    },
  },
  en: {
    translation: {
      nav: {
        dashboard: 'Dashboard',
        portfolios: 'Portfolios',
        transactions: 'Transactions',
        import: 'Import',
        realestate: 'Real Estate',
        otherassets: 'Other Assets',
        pipelines: 'Pipelines',
        captables: 'Cap Tables',
        tax: 'Taxes',
        dividends: 'Dividends',
        screener: 'Screener',
        community: 'Community',
        public: 'Public',
        pricing: 'Pricing',
        settings: 'Settings',
        logout: 'Logout',
      },
      auth: {
        login: 'Login',
        register: 'Register',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        fullName: 'Full Name',
        loginButton: 'Sign In',
        registerButton: 'Sign Up',
        noAccount: "Don't have an account?",
        hasAccount: 'Already have an account?',
        forgotPassword: 'Forgot password?',
        twoFactorCode: '2FA Code',
      },
      dashboard: {
        title: 'Portfolio Overview',
        netWorth: 'Net Worth',
        totalValue: 'Total Value',
        dayChange: 'Day Change',
        totalReturn: 'Total Return',
        allocation: 'Asset Allocation',
        topHoldings: 'Top Holdings',
        recentTransactions: 'Recent Transactions',
        performance: 'Performance',
      },
      portfolio: {
        title: 'Portfolios',
        create: 'Create Portfolio',
        name: 'Name',
        baseCurrency: 'Base Currency',
        holdings: 'Holdings',
        transactions: 'Transactions',
        performance: 'Performance',
        noHoldings: 'No holdings',
        addTransaction: 'Add Transaction',
      },
      holdings: {
        asset: 'Asset',
        quantity: 'Quantity',
        avgCost: 'Avg Cost',
        currentPrice: 'Current Price',
        value: 'Value',
        pnl: 'P&L',
        weight: 'Weight',
      },
      transactions: {
        title: 'Transactions',
        add: 'Add',
        import: 'Import',
        type: 'Type',
        date: 'Date',
        asset: 'Asset',
        quantity: 'Quantity',
        price: 'Price',
        total: 'Total',
        fees: 'Fees',
        notes: 'Notes',
        currency: 'Currency',
        selectAsset: 'Select asset',
        addDetails: 'Transaction details',
        searchAsset: 'Search by ticker or name...',
        noAssets: 'No assets found',
        createAsset: 'Create new asset',
        assetType: 'Asset type',
        ticker: 'Ticker',
        assetName: 'Name',
        notesPlaceholder: 'Optional note...',
        created: 'Transaction created',
        types: {
          buy: 'Buy',
          sell: 'Sell',
          dividend: 'Dividend',
          coupon: 'Coupon',
          transfer_in: 'Transfer In',
          transfer_out: 'Transfer Out',
          split: 'Split',
          fee: 'Fee',
          tax: 'Tax',
          interest: 'Interest',
        },
      },
      captable: {
        title: 'Cap Tables',
        create: 'Create Cap Table',
        companyName: 'Company Name',
        totalShares: 'Total Shares',
        optionPool: 'Option Pool',
        rounds: 'Rounds',
        shareholders: 'Shareholders',
        grants: 'Grants',
        waterfall: 'Waterfall Analysis',
        addRound: 'Add Round',
        addGrant: 'Add Grant',
        ownership: 'Ownership',
        fullyDiluted: 'Fully Diluted',
      },
      settings: {
        title: 'Settings',
        profile: 'Profile',
        security: 'Security',
        appearance: 'Appearance',
        language: 'Language',
        theme: 'Theme',
        currency: 'Currency',
        enable2FA: 'Enable 2FA',
        disable2FA: 'Disable 2FA',
        changePassword: 'Change Password',
      },
      depositComparison: {
        title: 'Better Than Deposits',
        subtitle: 'Instruments with higher yield at comparable risk',
        keyRate: 'CB Key Rate',
        depositRate: 'Typical Deposit',
        yield: 'Yield',
        risk: 'Risk',
        horizon: 'Horizon',
        liquidity: 'Liquidity',
        minAmount: 'Min. Amount',
        details: 'Details',
        collapse: 'Collapse',
        badgeBest: 'Best Pick',
        badgeSafe: 'Safe',
        badgePopular: 'Popular',
        vsDeposit: 'vs deposit',
        aboveDeposit: 'above deposit',
      },
      common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        confirm: 'Confirm',
        search: 'Search',
        filter: 'Filter',
        export: 'Export',
        noData: 'No data',
        back: 'Back',
        create: 'Create',
        previous: 'Previous',
        next: 'Next',
        pageOf: 'Page {{current}} of {{total}}',
        login: 'Login',
      },
      community: {
        title: 'Community',
        subtitle: 'Articles and analytics from investors',
        writeArticle: 'Write Article',
        searchPlaceholder: 'Search articles...',
        allCategories: 'All Categories',
        noArticles: 'No articles',
        noArticlesDescription: 'Be the first to share your thoughts',
        writeFirstArticle: 'Write first article',
        anonymousAuthor: 'Anonymous',
        backToArticles: 'Back to articles',
        articleNotFound: 'Article not found',
        share: 'Share',
        edit: 'Edit',
        delete: 'Delete',
        confirmDelete: 'Are you sure you want to delete this article?',
        views: 'views',
        followers: 'followers',
        follow: 'Follow',
        unfollow: 'Unfollow',
        comments: 'Comments',
        commentPlaceholder: 'Write a comment...',
        replyPlaceholder: 'Write a reply...',
        postComment: 'Post',
        reply: 'Reply',
        edited: 'edited',
        loginToComment: 'Login to leave a comment',
        noComments: 'No comments yet',
        category: {
          analysis: 'Analysis',
          strategy: 'Strategy',
          news: 'News',
          education: 'Education',
          review: 'Review',
          other: 'Other',
        },
      },
    },
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'ru',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
